import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const MoreVerticalIcon = React.memo<IconProps>(
  ({ className = '', size = 24, color = 'currentColor', onClick }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="5" r="1.5" fill={color} />
      <circle cx="12" cy="12" r="1.5" fill={color} />
      <circle cx="12" cy="19" r="1.5" fill={color} />
    </BaseIcon>
  ),
);

MoreVerticalIcon.displayName = 'MoreVerticalIcon';
